import { object, ObjectSchema, string } from "yup";

export const medicationNameSchema: ObjectSchema<{ name: string }> = object({
  name: string()
    .trim()
    .max(100, 'Medication Name must not exceed 100 characters')
    .required('Medication Name Required'),
})

export const medicationDosageSchema: ObjectSchema<{ dosage: string }>  = object({
  dosage: string().required('Medication Dosage Required')
})

export const medicationFrequencySchema: ObjectSchema<{ frequency: string }>  = object({
  frequency: string().required('Medication Frequency Required')
})

export function medicationSchema(key: string): object {
  switch (key) {
    case 'name':
      return medicationNameSchema;
    case 'dosage':
      return medicationDosageSchema;
    case 'frequency':
      return medicationFrequencySchema;
    default:
      return object({});
  }
}